import isNull from 'lodash/isNull';

import { getName } from 'country-list';

export const creditReviewToTableParser = ({
  easy_number: easyNumber,
  name,
  city,
  address,
  postal_code: postalCode,
  VAT,
  HRN,
  LEI,
  country: countryCode,
  sector,
  sectorRiskLevel,
  creditScore,
  oldScore,
  creditScoreDate,
  businessClimate,
  countryRiskAssessment,
  probabilityOfDefault,
  probabilityOfDefaultDefinition,
  requested,
  activity,
}) => {
  const country = countryCode ? getName(countryCode) || countryCode : '-';
  const creditScoreRow = {
    creditScore: isNull(creditScore) ? '-' : creditScore,
    oldScore,
    creditScoreDate,
  };
  return [
    easyNumber,
    [name, VAT, HRN, LEI, requested],
    isNull(country) ? '-' : country,
    isNull(sector) ? '-' : sector,
    isNull(city) ? '-' : [city, address],
    isNull(postalCode) ? '-' : postalCode,
    creditScoreRow,
    [isNull(probabilityOfDefault) ? '-' : probabilityOfDefault, probabilityOfDefaultDefinition],
    isNull(sectorRiskLevel) ? '-' : sectorRiskLevel,
    isNull(businessClimate) ? '-' : businessClimate,
    isNull(countryRiskAssessment) ? '-' : countryRiskAssessment,
    (requested && requested.score_date) || false,
    isNull(requested) ? false : requested,
    (requested && requested.monitoring) || false,
    activity,
  ];
};

export const creditReviewListToTableParser = data => data.map(creditReviewToTableParser);
